// extracted by mini-css-extract-plugin
export var boxItems = "_1p-1";
export var boxItemsLg = "_1p-2";
export var button = "_1p-7";
export var buttonLg = "_1p-8";
export var filterGroupBox = "_1p-0";
export var icon = "_1p-3";
export var iconSecondary = "_1p-6";
export var iconWrapper = "_1p-4";
export var iconWrapperLg = "_1p-5";